import { motion } from "framer-motion";
import { DURATION } from "../../constants/animations";

export default function FadeIn({
    children,
    duration = DURATION.NORMAL, // 0.9s - deliberate and visible
    delay = 0,
    amount = 0.1,
    direction = "up",
    init_y,
    className = "",
    style = {},
}) {
    let initialX = 0;
    let initialY = 0;

    if (direction === "left") initialX = -45;
    else if (direction === "right") initialX = 45;
    else if (direction === "down") initialY = -35;
    else initialY = init_y !== undefined ? init_y : 40;

    return (
        <motion.div
            initial={{
                opacity: 0,
                x: initialX,
                y: initialY,
            }}
            whileInView={{
                opacity: 1,
                x: 0,
                y: 0,
            }}
            transition={{
                duration: duration,
                delay: delay,
                ease: "linear", // Clean linear transition as requested
            }}
            viewport={{
                once: true,
                amount: amount,
            }}
            className={`gpu-accel ${className}`}
            style={{
                width: "100%",
                position: "relative",
                ...style,
            }}
        >
            {children}
        </motion.div>
    );
}
